import { render, staticRenderFns } from "./RootCert.vue?vue&type=template&id=92142300"
import script from "./RootCert.vue?vue&type=script&lang=js"
export * from "./RootCert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports